import React from "react";
import {connect} from "react-redux";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import CheckActivePicto from "../Picto/CheckActivePicto";
import FermerPicto from "../Picto/FermerPicto";


class TendancePopinItem extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            timeParution : this.props.timeParution,
        }
    }


    render() {
        const styles = StyleSheet.create({
            container : {
                flexDirection : "row",
                paddingVertical:22,
                paddingLeft:15
            },
            containerLabel : {
              width:"85%"
            },
            label : {
                fontFamily:this.props.theme.fonts.text,
                fontWeight:"600",
                fontSize:15,
                color: this.props.theme.colors.tertiary.black1.value,
            },
        });
        return (<View>
            <TouchableOpacity onPress={()=>{this.props.setTimeParution(this.props.value)}}>
            <View style={styles.container}>

                    <View style={styles.containerLabel}><Text style={styles.label}>{this.props.label}</Text></View>
                    { this.props.value === this.props.timeParution && <View ><CheckActivePicto isHeader={true} style={{width:24,height:24}} /></View> }

            </View>
            </TouchableOpacity>
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer,timeParution:state.tendanceReducer.timeParution};
}

export default connect(mapStateToProps)(TendancePopinItem);
